import { comparisonData } from '@/mocks/siteData';

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Why Vigorbuy Spreadsheet Makes Product Research Easier
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            See how Vigorbuy Spreadsheet compares to traditional shopping research methods across key dimensions.
          </p>
        </div>

        <div className="max-w-[800px] mx-auto overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="text-left py-4 px-4 md:px-6 text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  Feature
                </th>
                <th className="text-center py-4 px-4 md:px-6 text-sm font-semibold text-primary-600 whitespace-nowrap">
                  <div className="flex items-center justify-center gap-2">
                    <i className="ri-star-fill text-sm"></i>
                    Vigorbuy Spreadsheet
                  </div>
                </th>
                <th className="text-center py-4 px-4 md:px-6 text-sm font-semibold text-foreground-400 whitespace-nowrap">
                  Traditional Shopping
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={idx} className="border-b border-background-200/40 hover:bg-background-50 transition-colors">
                  <td className="py-4 px-4 md:px-6 text-sm font-medium text-foreground-800 whitespace-nowrap">
                    {row.feature}
                  </td>
                  <td className="py-4 px-4 md:px-6 text-center">
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full whitespace-nowrap">
                      <i className="ri-check-line text-xs"></i>
                      {row.vigorbuy}
                    </span>
                  </td>
                  <td className="py-4 px-4 md:px-6 text-center">
                    <span className="text-sm text-foreground-400 whitespace-nowrap">{row.traditional}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}